import { render, staticRenderFns } from "./Items.vue?vue&type=template&id=d4eea860&scoped=true&"
import script from "./Items.vue?vue&type=script&lang=ts&"
export * from "./Items.vue?vue&type=script&lang=ts&"
import style0 from "./Items.vue?vue&type=style&index=0&id=d4eea860&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4eea860",
  null
  
)

export default component.exports